import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { TfNotificationsService } from "./services/tf-notifications.service";
import { TfToastComponent } from "./components/tf-toast/tf-toast.component";

@NgModule({
    declarations: [
        TfToastComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TfToastComponent
    ],
    providers: [
        TfNotificationsService
    ]
})
export class TfNotificationsModule {
}
